import React from 'react'

function Footer() {
    return (
        <footer className="main-footer d-flex align-items-center justify-content-between flex-wrap">
            <span>
                &copy; 2024-2025 <a href="https://v4sureitsolution.com/">V4SUREITSOLUTIONS</a>. All rights reserved.
            </span>
            <span className="d-none d-sm-inline-block">
                <b>Version</b> 3.0.1
            </span>
        </footer>
    )
}

export default Footer